import { useState } from "react";
import {
  Form,
  Checkbox,
  Divider,
  Button,
  Icon,
  Dropdown,
  Message,
} from "semantic-ui-react";
import { Link } from "react-router-dom";
import { useAuth } from "../../../../../hooks";
import "./SettingsSidebarForm.scss";

export function SettingsSidebarForm({ darkLightTheme, setDarkLightTheme }) {
  const { logout } = useAuth();
  const [notifications, setNotifications] = useState(true);
  const [resetMsg, setResetMsg] = useState(false);
  const [showTutorialMsg, setShowTutorialMsg] = useState(false);

  const onLogout = () => {
    logout();
  };

  const handleReset = () => {
    setDarkLightTheme(false);
    setNotifications(true);
    setResetMsg(true);
    // eslint-disable-next-line no-undef
    setTimeout(() => setResetMsg(false), 2000);
  };

  const handleResetTutorials = () => {
    setShowTutorialMsg(true);
    // eslint-disable-next-line no-undef
    setTimeout(() => setShowTutorialMsg(false), 2000);
  };

  return (
    <Form className="settings-sidebar-form">
      <div className="settings-options">
        <div className="row">
          <div className="switch-label">
            <Icon
              name={darkLightTheme ? "moon" : "sun"}
              color={darkLightTheme ? "grey" : "yellow"}
            />
            <span>Modo Oscuro</span>
          </div>
          <Checkbox
            toggle
            checked={darkLightTheme}
            onChange={() => setDarkLightTheme(!darkLightTheme)}
          />
        </div>
        <div className="row">
          <div className="switch-label">
            <Icon name="bell" color={notifications ? "green" : "grey"} />
            <span>Notificaciones</span>
          </div>
          <Checkbox
            toggle
            checked={notifications}
            onChange={() => setNotifications(!notifications)}
          />
        </div>
      </div>
      <div className="sidebar-buttons">
        <Button
          className="setting-button"
          color="grey"
          onClick={handleReset}
          icon
          labelPosition="left"
        >
          <Icon name="undo" /> Restablecer configuración
        </Button>
        {/* <Button
          className="setting-button"
          color="teal"
          icon
          labelPosition="left"
          onClick={handleResetTutorials}
        >
          <Icon name="redo" /> Restablecer tutoriales
        </Button> */}
        <Button
          className="setting-button"
          as={Link}
          to="/student/support"
          color="blue"
          icon
          labelPosition="left"
        >
          <Icon name="help circle" /> Soporte y ayuda
        </Button>
      </div>
    </Form>
  );
}
